import type { Ref } from 'react';
import { useEffect, useRef } from 'react';

export function useScrollIntoView<TRef extends HTMLElement>(value: number): Ref<TRef> {
  const url = new URL(window.location.href);

  const urlParamValue = url.searchParams.get('comment');

  const ref = useRef<TRef>(null);

  useEffect(() => {
    if (urlParamValue === null || !ref.current || parseInt(urlParamValue, 10) !== value) {
      return;
    }

    ref.current.scrollIntoView({ behavior: 'smooth' });
  }, [value, urlParamValue]);

  return ref;
}
